import { Form, useFormikContext } from "formik";
import PropTypes from "prop-types";
import { useFacets } from "../../hooks/useFacets";
import { Button } from "app/components/ui/Button/Button";
import { useIntl } from "react-intl";
import "./FilterPopoverForm.scss";
import classNames from "classnames";
import { sendTagOnProductsFilter } from "app/utils/analytics";
import { FacetFilter } from "../FacetFilter";

export const FilterPopoverForm = ({ facetId, onSubmit }) => {
	const { formatMessage } = useIntl();
	const { values, resetForm } = useFormikContext();
	const { facets } = useFacets();

	const { filters = [] } = facets.find(facet => facet.facetId === facetId);

	if (filters.length === 0) {
		return null;
	}

	const filterIds = filters.map(filter => filter?.field);
	const selectedValues = filterIds.reduce((acc, filterId) => {
		acc[filterId] = values?.[filterId] || [];
		return acc;
	}, {});

	const selectedValuesCount = Object.values(selectedValues).reduce(
		(acc, value) => acc + value.length,
		0
	);

	const handleResetFacet = () => {
		const emptyFilters = filterIds.reduce((acc, filterId) => {
			acc[filterId] = [];
			return acc;
		}, {});

		resetForm({ values: { ...values, ...emptyFilters } });
	};

	const handleApply = () => {
		if (onSubmit) {
			onSubmit(facetId, selectedValues || null);
		}

		sendTagOnProductsFilter(facetId, selectedValues || null);
	};

	const canShowResetButton = selectedValuesCount > 0;

	return (
		<Form className="filter-popover-form">
			{filters.map(filter => {
				return <FacetFilter key={filter?.field} filter={filter} />;
			})}

			<footer className="filter-popover-form__actions">
				<Button
					size="sm"
					className="filter-popover-form__apply-button"
					onClick={handleApply}
					type="submit"
				>
					{formatMessage({
						id: "sdp.filter.apply.button.label",
					})}
				</Button>

				<Button
					variant="borderless"
					size="sm"
					onClick={handleResetFacet}
					className={classNames("filter-popover-form__reset-button", {
						"filter-popover-form__reset-button--visible": canShowResetButton,
					})}
					aria-hidden={!canShowResetButton}
					tabIndex={canShowResetButton ? 0 : -1}
				>
					{formatMessage({
						id: "sdp.filter.reset.button.label",
					})}
				</Button>
			</footer>
		</Form>
	);
};

FilterPopoverForm.propTypes = {
	facetId: PropTypes.string.isRequired,
	onSubmit: PropTypes.func,
};
